import * as React from "react";
/**
 *
 * @param props
 */
export var NavbarTitle = function (props) { return (React.createElement("div", { className: "scl-o-navbar__title" }, props.children)); };
